import { createFilterOptions } from '@mui/material'
import { Filter } from 'components/core/search-filter/filter'
import { SearchRolesRequest } from 'pbts/c1/api/iam/v1/iam'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useGetAllRoles } from 'redux_toolkit/roles'

const RoleFilterOptions = createFilterOptions<string>({})

type UserRoleFilterProps = {
    value?: Array<string>
    onChange: (updated: { roleIds: Array<string> }, shouldPropagate?: boolean) => void
}

export const UserRoleFilter = ({ value, onChange: _onChange }: UserRoleFilterProps): React.ReactElement => {
    const intl = useIntl()
    const { data } = useGetAllRoles(SearchRolesRequest.create({}), { evictionAfterSeconds: 60 })

    const flattened = data.flat()
    const renderLabel = useCallback(
        (id: string): string => flattened?.find((r) => r.id === id)?.displayName || '',
        [flattened],
    )

    const onChange = useCallback((roleIds: Array<string>) => _onChange({ roleIds }, true), [_onChange])

    return (
        <Filter
            label={intl.formatMessage({
                id: 'user_filter_role_type',
                defaultMessage: 'Role',
            })}
            options={flattened?.map((r) => r.id) || []}
            selected={value}
            onChange={onChange}
            filterOptions={RoleFilterOptions}
            renderLabel={renderLabel}
        />
    )
}
